module.exports = __webpack_public_path__ + "img/chart-scatter-3d.c4c1ef47.svg";